import { useParams } from "react-router-dom";
import { useCommunity } from "@/context/CommunityContext";
import TopBar from "@/components/TopBar";

const PAGES = {
  impressum: ["Impressum", "legal_imprint"],
  datenschutz: ["Datenschutz", "legal_privacy"],
  nutzungsbedingungen: ["Nutzungsbedingungen", "legal_terms"],
  "community-regeln": ["Community-Regeln", "legal_rules"],
};

export default function Legal() {
  const { page } = useParams();
  const { community } = useCommunity();
  const [title, field] = PAGES[page] || ["Rechtliches", null];
  const text = field ? community?.[field] : null;

  return (
    <div>
      <TopBar back="/" title={title} />
      <div className="mx-auto max-w-2xl px-5 py-8" data-testid="legal-page">
        <h1 className="text-4xl">{title}</h1>
        {text ? (
          <p className="mt-6 whitespace-pre-line text-base leading-relaxed">{text}</p>
        ) : (
          <p className="mt-6 text-sm text-[var(--ink-soft)]">
            Für diese Seite ist noch kein Text hinterlegt. Die Gemeinde kann ihn im Adminbereich eintragen.
          </p>
        )}
      </div>
    </div>
  );
}
